import angelWasteLogo from "../../assets/brands/angelwaste.svg";
import cutPriceLogo from "../../assets/brands/cutprice.svg";
import actSkipHireLogo from "../../assets/brands/actskiphire.svg";
import capitalHireLogo from "../../assets/brands/capitalhire.svg";
import crgSkipsLogo from "../../assets/brands/crgskips.svg";
import budgetWbLogo from "../../assets/brands/budgetwastebags.svg";
import cbrSkipsLogo from "../../assets/brands/cbrskips.svg";
import discountSkipsWbLogo from "../../assets/brands/discountskipswb.svg";

import React, {useContext} from "react";
import {OscarContext, OscarContextType} from "@/components/context/OscarContext.tsx";

export type BrandLogoProps = React.ImgHTMLAttributes<HTMLImageElement>

const BrandLogo = React.forwardRef<
    HTMLImageElement,
    BrandLogoProps
>(({...props }, ref) => {
    const { localConfig } = useContext(OscarContext) as OscarContextType

    let brandLogo;
    if (localConfig.brand === 'angel_waste') {
        brandLogo = angelWasteLogo;
    } else if (localConfig.brand === 'cut_price_skips') {
        brandLogo = cutPriceLogo;
    } else if (localConfig.brand === 'capital_hire') {
        brandLogo = capitalHireLogo;
    } else if (localConfig.brand === 'crg_skips') {
        brandLogo = crgSkipsLogo;
    } else if (localConfig.brand === "cbr_skips") {
        brandLogo = cbrSkipsLogo;
    } else if (localConfig.brand === "discount_skips_wb") {
        brandLogo = discountSkipsWbLogo;
    } else if (localConfig.brand === "budget_wb") {
        brandLogo = budgetWbLogo;
    } else {
        brandLogo = actSkipHireLogo;
    }

    return (
        <img
            ref={ref}
            src={brandLogo} alt={"Logo"}
            {...props}
        />
    );
})
BrandLogo.displayName = "BrandLogo"
export default BrandLogo;